export type VerticalStepperDataType = {
	label: string;
	description?: string;
};

export const verticalStepperData = [
	{
		label: 'Organization details',
	},
	{
		label: 'Organization logo',
		description: 'Organization logo will be used to brand event website, auction website, and emails.',
	},
	{
		label: 'Payment Processor',
		description:
			'Connect your preferred payment processor to collect payments. Payments (minus transaction fees) are deposited directly into your account.',
	},
];
